import { useEffect } from "react";

/* ─────────────────────────────────────────────
   IMAGE IMPORTS — src/assets/images/blogs/
───────────────────────────────────────────── */
import ThumbTesla      from "../../assets/images/blogs/tesla-india.webp";
import ThumbBattery    from "../../assets/images/blogs/battery-swapping.webp";
import ThumbOla        from "../../assets/images/blogs/ola-electric.webp";
import ThumbEvFire     from "../../assets/images/blogs/ev-fire.webp";
import VehicleTrend     from "../../assets/images/blogs/vehicle-trend.webp";
import ThumbFiat       from "../../assets/images/blogs/fiat-millecento.webp";
import ThumbConference from "../../assets/images/blogs/lead-battery-conference.webp";
import ThumbInfra      from "../../assets/images/blogs/electrical-infrastructure.webp";
import NaturalGas     from "../../assets/images/blogs/Natural-Gas.webp";
import EnergyDNA     from "../../assets/images/blogs/energy-dna-green-transition.webp"; 
import BuildBack    from "../../assets/images/blogs/build-back-better.webp"; 
import WinnersAFSIA    from "../../assets/images/blogs/Winners-AFSIA.webp";
import GreenElectric    from "../../assets/images/blogs/green-electric.webp";

/* ─────────────────────────────────────────────
   BlogNews.jsx
   Prefix      : bn-
   Fonts       : Montserrat (headings) | Roboto (body)
   Purple      : #743FAC
   BG main     : #1A1A1A
   BG feat     : #000000
   BG small    : #000000
   Max-W       : 1600px  |  Pad: 221px
   Breaks      : 768px   |  480px

   IMAGE CLASSES — separated:
     bn-feat-img     → featured card image wrapper
     bn-feat-img img → featured card <img>
     bn-sm-img       → small card image wrapper (250x160)
     bn-sm-img img   → small card <img>
─────────────────────────────────────────────── */

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Roboto:wght@300;400;500;700&display=swap');

  .bn-wrap *, .bn-wrap *::before, .bn-wrap *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .bn-wrap {
    font-family: 'Roboto', sans-serif;
    background: #1A1A1A;
    color: #ffffff;
    width: 100%;
    overflow-x: hidden;
  }

  .bn-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 221px;
    padding-right: 221px;
    width: 100%;
  }

  /* ══════════════════════════
     SCROLL FADE-UP
  ══════════════════════════ */
  .bn-fade-up {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .bn-fade-up.bn-in {
    opacity: 1;
    transform: translateY(0);
  }
  .bn-delay-1 { transition-delay: 0.08s; }
  .bn-delay-2 { transition-delay: 0.18s; }
  .bn-delay-3 { transition-delay: 0.28s; }
  .bn-delay-4 { transition-delay: 0.38s; }

  /* ══════════════════════════
     SECTION
  ══════════════════════════ */
  .bn-section {
    width: 100%;
    background: #1A1A1A;
    padding: 60px 0 100px 0;
  }

  .bn-heading {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    margin-bottom: 60px;
    line-height: 140%;
  }

  /* ══════════════════════════
     FEATURED STACK
     3 rows — image 50% | body 50%
  ══════════════════════════ */
  .bn-featured {
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-bottom: 30px;
  }

  .bn-card-feat {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #000000;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(255,255,255,0.06);
    min-height: 400px;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    padding: 20px 40px 20px 20px;
    transition: border-color 0.4s cubic-bezier(0.4,0,0.2,1),
                transform     0.4s cubic-bezier(0.4,0,0.2,1);
  }
  .bn-card-feat:hover {
    border-color: rgba(116,63,172,0.55);
    transform: translateY(-3px);
  }
  .bn-card-feat:hover .bn-feat-img img {
    transform: scale(1.06);
    filter: brightness(1.08) saturate(1.1);
  }
  .bn-card-feat:hover .bn-feat-readmore {
    color: #9b59f5;
  }
  .bn-card-feat:hover .bn-feat-arrow {
    transform: translateX(5px);
  }

  /* ── FEATURED IMAGE WRAPPER ── */
  .bn-feat-img {
    overflow: hidden;
    background: #000000;
    border-radius: 10px;
    width:683px;
  }
  .bn-feat-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 10px;
    transition: transform 0.4s cubic-bezier(0.4,0,0.2,1),
                filter     0.4s ease;
  }

  /* ── FEATURED BODY ── */
  .bn-feat-body {
    padding: 0px 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
  }
  .bn-feat-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    max-width: 350px;
  }
  .bn-feat-readmore {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #743FAC;
    text-decoration: none;
    transition: color 0.25s ease;
    width: fit-content;
  }
  .bn-feat-arrow {
    display: inline-flex;
    align-items: center;
    transition: transform 0.25s ease;
    line-height: 1;
  }

  /* ══════════════════════════
     SMALL 2x2 GRID
     FIXED: grid-template-columns matches
     250px image + remaining body
  ══════════════════════════ */
  .bn-small-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  .bn-card-small {
    display: grid;
    grid-template-columns: 250px 1fr;
    background: #000000;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(255,255,255,0.06);
    min-height: 160px;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    padding: 20px;
    gap: 0;
    transition: border-color 0.4s cubic-bezier(0.4,0,0.2,1),
                transform     0.4s cubic-bezier(0.4,0,0.2,1);
  }
  .bn-card-small:hover {
    border-color: rgba(116,63,172,0.55);
    transform: translateY(-3px);
  }
  .bn-card-small:hover .bn-sm-img img {
    transform: scale(1.06);
    filter: brightness(1.08) saturate(1.1);
  }
  .bn-card-small:hover .bn-sm-readmore {
    color: #9b59f5;
  }
  .bn-card-small:hover .bn-sm-arrow {
    transform: translateX(5px);
  }

  /* ── SMALL IMAGE WRAPPER — fixed 250x160 ── */
  .bn-sm-img {
    width: 250px;
    height: 160px;
    flex-shrink: 0;
    overflow: hidden;
    background: #000000;
    border-radius: 8px;
  }
  .bn-sm-img img {
    width: 250px;
    height: 160px;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 8px;
    transition: transform 0.4s cubic-bezier(0.4,0,0.2,1),
                filter     0.4s ease;
  }

  /* ── SMALL BODY ── */
  .bn-sm-body {
    padding: 0px 0px 0px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
  .bn-sm-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: #e0e0e0;
    line-height: 1.45;
    max-width: 246px;
  }
  .bn-sm-date {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: rgba(255,255,255,0.42);
  }
  .bn-sm-readmore {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #743FAC;
    text-decoration: none;
    transition: color 0.25s ease;
    width: fit-content;
  }
  .bn-sm-arrow {
    display: inline-flex;
    align-items: center;
    transition: transform 0.25s ease;
    line-height: 1;
  }

  /* ══════════════════════════
     RESPONSIVE 768px
  ══════════════════════════ */
  @media (max-width: 768px) {
    .bn-inner { padding-left: 32px; padding-right: 32px; }
    .bn-section { padding: 48px 0; }
    .bn-heading { font-size: 32px; margin-bottom: 40px; }
    .bn-featured { margin-bottom: 40px;}

    .bn-card-feat {
      grid-template-columns: 1fr;
      min-height: auto;
      padding: 16px;
    }
    .bn-feat-img { height: 270px; }
    .bn-feat-body { padding: 20px 0 0 0; gap: 14px; }
    .bn-feat-title { font-size: 20px; max-width: 100%; }

    .bn-small-grid { grid-template-columns: 1fr ; gap:24px;}
    .bn-card-small { grid-template-columns: 250px 1fr; min-height: auto;  }
    .bn-sm-img { width: 250px; height: 120px; }
    .bn-sm-img img { width: 250px; height: 120px; }
  }

  /* ══════════════════════════
     RESPONSIVE 480px
  ══════════════════════════ */
  @media (max-width: 480px) {
   .bn-section { padding: 50px 0; }
    .bn-inner { padding-left: 16px; padding-right: 16px; }
    .bn-card-feat {  padding: 19px 17px 26px 17px; }
    .bn-feat-body {padding: 14px 0 0 0; gap:10px;}
    .bn-heading { font-size: 30px; }
    .bn-feat-img { height: 180px;width:100%; }
    .bn-feat-title { font-size: 20px; }
    .bn-card-small { grid-template-columns: 166px 1fr; }
    .bn-sm-img { width: 166px; height: 140px; }
   
    .bn-sm-title { font-size: 16px; }
    .bn-sm-body { padding: 0px 0px 0px 16px;}
    .bn-card-small { padding: 15px 4px 16px 14px;}
    .bn-sm-date { font-size: 14px; }
    .bn-sm-readmore { font-size: 14px; }
  }
`;

/* ─── DATA ─────────────────────────────────── */
const FEATURED = [
  {
    title: "What Happened With Tesla India?",
    img: ThumbTesla,
    link: "/blog/what-happened-with-tesla-india",
  },
  {
    title: "Is Battery Swapping a viable solution for India?",
    img: ThumbBattery,
    link: "/blog/is-battery-swapping-a-viable-solution-for-india",
  },
  {
    title: "Is OLA Electric's ambitions for EVs in India flawed?",
    img: ThumbOla,
    link: "/blog/is-ola-electrics-ambitions-for-evs-in-india-flawed/",
  },
];

const SMALL = [
  {
    title: "Electric Vehicle Trends In India And Top Selling EVs in 2021",
    date: "February 19, 2022",
    img: VehicleTrend ,
    link: "/blog/electric-vehicle-trends-in-india-and-top-selling-manufactures-in-2021/",
  },
  {
    title: "What is the deal with EVs catching fire? And why should you care?",
    date: "December 30, 2021",
    img: ThumbEvFire,
    link: "/blog/what-is-the-deal-with-evs-catching-fire-and-why-should-you-care/",
  },
  {
    title: "World's First Electrified Vintage 1954 Fiat Millecento",
    date: "September 29, 2021",
    img: ThumbFiat,
    link: "/blog/worlds-first-electrified-vintage-1954-fiat-millecento/",
  },
  {
    title: "The European Lead Battery Conference & Exhibition is live and online 22-24 September",
    date: "April 14, 2021",
    img: ThumbConference,
    link: "/blog/the-european-lead-battery-conference-exhibition-is-live-and-online-22-24-september/",
  },
  {
    title: "The Surge in Electrification of Transportation Requires a Sustainable and Resilient Electrical Infrastructure",
    date: "April 14, 2021",
    img: ThumbInfra,
    link: "/blog/the-surge-in-electrification-of-transportation-requires-a-sustainable-and-resilient-electrical-infrastructure/",
  },
  {
    title: "How Natural Gas Utilities Play a Role in the Future of Our Energy System",
    date: "April 14, 2021",
    img: NaturalGas,
    link: "/blog/how-natural-gas-utilities-play-a-role-in-the-future-of-our-energy-system/",
  },
  {
    title: "Winners of AFSIA Solar Awards announced",
    date: "April 6, 2021",
    img: WinnersAFSIA,
    link: "/blog/winners-of-afsia-solar-awards-announced/",
  },
  {
    title: "Why we must unlock energy’s DNA to enable a green transition",
    date: "April 6, 2021",
    img: EnergyDNA ,
    link: "/blog/why-we-must-unlock-energys-dna-to-enable-a-green-transition/",
  },
  {
    title: "How ‘green’ are electric cars?",
    date: "April 6, 2021",
    img: GreenElectric ,
    link: "/blog/how-green-are-electric-cars/",
  },
  {
    title: "Build back better – with energy efficiency improvements",
    date: "April 6, 2021",
    img: BuildBack,
    link: "/blog/build-back-better-with-energy-efficiency-improvements/",
  },
  
  
];

/* ─── SCROLL REVEAL ─────────────────────────── */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".bn-fade-up");
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("bn-in");
        }),
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

/* ─── ARROW SVG ─────────────────────────────── */
function ArrowIcon({ cls }) {
  return (
    <span className={cls} aria-hidden="true">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 8h10M9 4l4 4-4 4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

/* ─── FEATURED CARD ─────────────────────────── */
function FeaturedCard({ item, delayClass }) {
  return (
    <a
      href={item.link}
      className={`bn-card-feat bn-fade-up ${delayClass}`}
      aria-label={item.title}
    >
      <div className="bn-feat-img">
        <img src={item.img} alt={item.title} loading="lazy" />
      </div>
      <div className="bn-feat-body">
        <h3 className="bn-feat-title">{item.title}</h3>
        <span className="bn-feat-readmore">
          Read More <ArrowIcon cls="bn-feat-arrow" />
        </span>
      </div>
    </a>
  );
}

/* ─── SMALL CARD ────────────────────────────── */
function SmallCard({ item, delayClass }) {
  return (
    <a
      href={item.link}
      className={`bn-card-small bn-fade-up ${delayClass}`}
      aria-label={item.title}
    >
      <div className="bn-sm-img">
        <img src={item.img} alt={item.title} loading="lazy" />
      </div>
      <div className="bn-sm-body">
        <h3 className="bn-sm-title">{item.title}</h3>
        {item.date && <span className="bn-sm-date">{item.date}</span>}
        <span className="bn-sm-readmore">
          Read More <ArrowIcon cls="bn-sm-arrow" />
        </span>
      </div>
    </a>
  );
}

/* ─── ROOT EXPORT ───────────────────────────── */
export default function Blogs() {
  useScrollReveal();

  const delays = ["bn-delay-1", "bn-delay-2", "bn-delay-3", "bn-delay-4"];

  return (
    <>
      <style>{CSS}</style>
      <div className="bn-wrap">
        <section className="bn-section">
          <div className="bn-inner">

            <h2 className="bn-heading bn-fade-up bn-delay-1">
              Blog &amp; News
            </h2>

            {/* Featured 3 stacked rows */}
            <div className="bn-featured">
              {FEATURED.map((item, i) => (
                <FeaturedCard key={i} item={item} delayClass={delays[i % 4]} />
              ))}
            </div>

            {/* Small 2x2 grid */}
            <div className="bn-small-grid">
              {SMALL.map((item, i) => (
                <SmallCard key={i} item={item} delayClass={delays[i % 4]} />
              ))}
            </div>

          </div>
        </section>
      </div>
    </>
  );
}